import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { StartersSpaceStyle } from '../../../starters/styles/StarterStyles';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { DropDownListType } from './StartersSpace';

export interface StartersSpaceDropDownNonAngularProps{
  readonly allOption: ListItem;
  readonly dropDownItems: DropDownListType;
  readonly onConnectionTypeSelected: (connectionTypeSelected: string) => void;
}

export type StartersSpaceDropDownProps = StartersSpaceDropDownNonAngularProps;

export class StartersSpaceDropDown extends React.PureComponent<StartersSpaceDropDownProps> {

  private getSelectedValueDataFromDropDown(): ListItem {
    for (let item of this.props.dropDownItems.items) {
      if (item.value === this.props.dropDownItems.selectedValue) {
        return item;
      }
    }
  }

  public render(): JSX.Element {
    const dropdownProps = {
      list: <List {...this.props.dropDownItems}/>,
      onChange: this.props.onConnectionTypeSelected,
      type: DropdownButtonType.Line,
      value: this.props.dropDownItems.selectedValue,
      testId: 'starters-dropdown-control',
      label: '',
      className: StartersSpaceStyle.startersDropdown,
    };

    return(
      <div className={ExplorerStyles.ToolbarButtonGroup}>
        <span className={ExplorerStyles.ToolbarDropdownLabel}> {Messages.filterByTypeDropdown_label_for_starters()} </span>
        <SingleSelectDropdown {...dropdownProps}>
          {this.getSelectedValueDataFromDropDown().content}
        </SingleSelectDropdown>
      </div>
    );
  }
}
